var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("btn.uploadInvoice"),
                isShowFollow: false,
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      "label-position": "top",
                      rules: _vm.rules,
                      model: _vm.form,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentNo",
                                  label:
                                    _vm.$t("importBillUpload.paymentNo") + "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.paymentNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "paymentNo", $$v)
                                    },
                                    expression: "form.paymentNo",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "p-color" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "exportCostSlipUpload.payeeContactShipping"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentWay",
                                  label:
                                    _vm.$t("importBillUpload.paymentWay") +
                                    "：",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { disabled: _vm.supplyInvoice },
                                    model: {
                                      value: _vm.form.paymentWay,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentWay", $$v)
                                      },
                                      expression: "form.paymentWay",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "01" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "importBillUpload.paymentInCny"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    this.pol != "CNNSA" && this.pol != "CNYPG"
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: "02" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "importBillUpload.paymentInUsd"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    this.pol != "CNNSA" && this.pol != "CNYPG"
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: "03" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "importBillUpload.paymentInHkd"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "00" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "importBillUpload.originalCurrencyPay"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    this.pol != "CNNSA" && this.pol != "CNYPG"
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: "04" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "importBillUpload.onlycny"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "p-color" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "exportCostSlipUpload.specialPaymentContact"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.paymentWay === "01"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 14 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountAllRMB",
                                      label: "CNY：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountAllRMB,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountAllRMB",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountAllRMB",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountAllRMBFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "AllRMB"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(
                                              file,
                                              "AllRMB"
                                            )
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountAllRMBFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.paymentWay === "02"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 14 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountAllUSD",
                                      label: "USD：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountAllUSD,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountAllUSD",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountAllUSD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountAllUSDFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "AllUSD"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(
                                              file,
                                              "AllUSD"
                                            )
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountAllUSDFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.paymentWay === "03"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 14 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountAllHKD",
                                      label: "HKD：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountAllHKD,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountAllHKD",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountAllHKD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountHKDFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "AllHKD"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(
                                              file,
                                              "AllHKD"
                                            )
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountAllHKDFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.paymentWay === "00"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 14 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountRMB",
                                      label: "CNY：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountRMB,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountRMB", $$v)
                                        },
                                        expression: "form.amountRMB",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountRMBFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(file, "RMB")
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file, "RMB")
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountRMBFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountUSD",
                                      label: "USD：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountUSD,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountUSD", $$v)
                                        },
                                        expression: "form.amountUSD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountUSDFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(file, "USD")
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file, "USD")
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountUSDFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountHKD",
                                      label: "HKD：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountHKD,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountHKD", $$v)
                                        },
                                        expression: "form.amountHKD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountHKDFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(file, "HKD")
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file, "HKD")
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountHKDFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.paymentWay === "04"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 14 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountOCNY",
                                      label: "CNY：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountOCNY,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountOCNY", $$v)
                                        },
                                        expression: "form.amountOCNY",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountOCNYFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(file, "OCNY")
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(
                                              file,
                                              "OCNY"
                                            )
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountOCNYFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "amountOUSD",
                                      label: "USD：",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountOUSD,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountOUSD", $$v)
                                        },
                                        expression: "form.amountOUSD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-top": "26px" },
                                    attrs: { prop: "amountOUSDFileId" },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(file, "OUSD")
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(
                                              file,
                                              "OUSD"
                                            )
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          accept: _vm.acceptList,
                                          "file-list": _vm.amountOUSDFileList,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-upload2",
                                              size: "small",
                                              type: "primary",
                                              plain: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.selectFile"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", { staticClass: "p-color" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("exportCostSlipUpload.uploadInstructions")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceWay",
                                  label:
                                    _vm.$t("exportCostSlipUpload.invoiceWay") +
                                    "：",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.form.invoiceWay,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "invoiceWay", $$v)
                                      },
                                      expression: "form.invoiceWay",
                                    },
                                  },
                                  _vm._l(_vm.invoiceWayList, function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                        value: item.codeValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "p-color" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "exportCostSlipUpload.onlyElectronicInvoice"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "taxpayerIdentificationNumber",
                                  label:
                                    _vm.$t(
                                      "exportCostSlipUpload.taxpayerIdentificationNumber"
                                    ) + "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 100,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value:
                                      _vm.form.taxpayerIdentificationNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "taxpayerIdentificationNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.taxpayerIdentificationNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "address",
                                  label:
                                    _vm.$t("exportCostSlipUpload.address") +
                                    "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 300,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "phone",
                                  label:
                                    _vm.$t("exportCostSlipUpload.phone") + "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 40,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "bank",
                                  label:
                                    _vm.$t("exportCostSlipUpload.bank") + "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 120,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.bank,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "bank", $$v)
                                    },
                                    expression: "form.bank",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "account",
                                  label:
                                    _vm.$t("exportCostSlipUpload.account") +
                                    "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 40,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.account,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "account", $$v)
                                    },
                                    expression: "form.account",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "consignee",
                                  label:
                                    _vm.$t("exportCostSlipUpload.consignee") +
                                    "：",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 300,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.consignee,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consignee", $$v)
                                    },
                                    expression: "form.consignee",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "soaNo",
                                  label: _vm.$t("exportCostSlipUpload.soaNo"),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 50,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.soaNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "soaNo", $$v)
                                    },
                                    expression: "form.soaNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceNumber",
                                  label: _vm.$t(
                                    "exportCostSlipUpload.invoiceNumber"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 50,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.invoiceNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceNumber", $$v)
                                    },
                                    expression: "form.invoiceNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "bankUsd",
                                  label: _vm.$t("exportCostSlipUpload.bankUsd"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 120,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.bankUsd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "bankUsd", $$v)
                                    },
                                    expression: "form.bankUsd",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "accountUsd",
                                  label: _vm.$t(
                                    "exportCostSlipUpload.accountUsd"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 40,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.accountUsd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountUsd", $$v)
                                    },
                                    expression: "form.accountUsd",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "remark",
                                  label: _vm.$t("exportCostSlipUpload.remark"),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: 2000,
                                    disabled: _vm.supplyInvoice,
                                  },
                                  model: {
                                    value: _vm.form.remark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "remark", $$v)
                                    },
                                    expression: "form.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-button" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.save")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }